import script from "./WorkflowAggregatesTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowAggregatesTemplate.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowAggregatesTemplate.vue?vue&type=style&index=0&id=55001990&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55001990"]])

export default __exports__